var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"spr-roundbox-1 spr-cloud-check",class:{ 'checked spr-shadow': _vm.checked, 'unchecked': !_vm.checked },attrs:{"tabindex":_vm.tabindex},on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }